import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RouteRecommendationService } from '../../../services/route-recommendation.service';
import {
  IRouteHiddenReason,
  IRouteHiddenReasonSelection,
} from '../../../interfaces/route-recommendations/route-rejection-reason';

@Component({
  selector: 'route-hide-reason-dialog',
  templateUrl: './route-hide-reason-dialog.component.html',
  styleUrls: ['./route-hide-reason-dialog.component.scss'],
})
export class RouteHideReasonDialogComponent implements OnInit {
  @Output() onConfirmHide: EventEmitter<IRouteHiddenReasonSelection> =
    new EventEmitter<IRouteHiddenReasonSelection>();

  @Input() visible: boolean = false;

  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  reasons: IRouteHiddenReason[] = [];

  hiddenReason: number = null;
  reasonText = '';

  constructor(private routeRecommendationService: RouteRecommendationService) {}

  ngOnInit() {
    void this.getReasons();
  }

  async getReasons() {
    try {
      let response = await this.routeRecommendationService.searchRouteHiddenReasons({});
      this.reasons = response.filter((x) => x.active == true);
    } catch (error) {}
  }

  needsTextInput(hiddenReason: number) {
    const x = this.reasons.find((x) => x.id == hiddenReason);

    if (x != null && x.inputRequired == true) {
      return true;
    }

    return false;
  }

  canSubmitReason() {
    const x = this.reasons.find((x) => x.id == this.hiddenReason);

    if (x != null && (this.reasonText.length > 0 || x.inputRequired == false)) {
      return true;
    }
    return false;
  }

  onHideRouteClick() {
    this.onConfirmHide.emit({
      routeHiddenReasonId: this.hiddenReason,
      routeHiddenComment: this.reasonText,
    });
  }

  onShow() {
    this.hiddenReason = null;
    this.reasonText = '';
  }
}
